
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
    emits: ['logout'],
    setup(_, { emit }) {
        const isDarkTheme = ref(false)
        const onLogout = () => emit('logout')

        const onToggleTheme = () => {
            const html = document.documentElement

            if (isDarkTheme.value) {
                localStorage.setItem('spark-bpms-m-theme', 'light')
                isDarkTheme.value = false
                html.setAttribute('data-theme', 'light')
            } else {
                localStorage.setItem('spark-bpms-m-theme', 'dark')
                isDarkTheme.value = true
                html.setAttribute('data-theme', 'dark')
            }
        }

        // 1
        onMounted(() => {
            const theme = localStorage.getItem('spark-bpms-m-theme')
            
            if (theme && theme === 'dark') {
                isDarkTheme.value = true
            } else {
                isDarkTheme.value = false
            }
        })

        return {
            isDarkTheme,
            onLogout,
            onToggleTheme
        }
    }
})
